<div class="mb-4 quiz-multiple-choice-radios" >
  @for (option of question.options; track option) {
    <div>
      <label class="custom-input">
        <span [innerHTML]="option.text"></span>
        @if (showFeedback && option.isCorrect) {
          <span class="icon-gecko-check text-success ml-1"></span>
        }
        @if (showFeedback && isSelected(option.id) && !option.isCorrect) {
          <span
          class="icon-gecko-delete text-warning ml-1"></span>
        }
        <input type="radio" [disabled]="showFeedback || isOffline" [name]="question.id" (change)="onSelectionChanged(option)"
          name="radio">
        <span class="radiobtn"></span>
        @if (showFeedback && isSelected(option.id)) {
          <span class="text-info small">
            <div ebsTechnicalContent [innerContent]="option.commentsHtml" id="correctComments"></div>
          </span>
        }
      </label>
    </div>
  }
  @if (showFeedback && isCorrect && question.correctCommentsHtml != null) {
    <div ebsTechnicalContent id="correctComments"
    [innerContent]="question.correctCommentsHtml" class="text-info small"></div>
  }
  @if (showFeedback && !isCorrect && question.incorrectCommentsHtml !=null) {
    <div ebsTechnicalContent id="incorrectComments" [innerContent]="question.incorrectCommentsHtml"
    class="text-info small"></div>
  }
  @if (showFeedback && question.neutralCommentsHtml !=null) {
    <div ebsTechnicalContent id="neutralComments" [innerContent]="question.neutralCommentsHtml" class="text-info small"
    ></div>
  }
</div>